
    import Vue from 'vue';
    import XSummary from '@/apps/shared/components/summary.vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import DateService from '@/apps/shared/utils/formatDate';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SummaryDetails } from '@/apps/shared/models/summaryDetails';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';

    export default Vue.extend({
        name: 'ElectronicDeviceSummary',
        components: {
            XSummary,
        },
        data() {
            return {
                productDetails: {
                    effectDate: null,
                    expirationDate: null,
                    name: null,
                    email: null,
                    telephone: null,
                    cover: null,
                    planDescription: null,
                    firstPaymentFee: null,
                    capital: null,
                    undiscountedPrice: null,
                    rate: null,
                    cupeUrl: null,
                    breadcrumbItems: [
                        { text: 'Inicio', path: '/tecnologia' },
                        { text: 'Resumen', path: 'tecnologia/resumen' },
                    ],
                    icon: {
                        src: '/Logos/tecnologia.svg',
                        alt: 'Tecnologia',
                        title: 'Tecnologia'
                    },
                    product: '/tecnologia'
                } as SummaryDetails,
                GUiD: null,
                referente: null,
                medium: null,
                pas: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Tecnología';
                const actualPath = '/tecnologia';
                const actualStep = 'summary';

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getCUPE() {
                const email = "";
                const productId = 1000;
                NF.UI.Page.block();
                var timeStart = new Date().getTime();
                CUPEService.GetCUPEUrl(productId, email, this.GUiD).then((response) => {
                    var endTime = new Date().getTime();
                    var secondCharge = Math.round((endTime - timeStart) / 1000);

                    const eventData = {
                        'pas': this.pas,
                        'email': this.productDetails.email,
                        'product': 'tecnologia',
                        'event': 'cotizador-tecnologia-resumen',
                        'carga': secondCharge,
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);

                    this.productDetails.cupeUrl = response.preferenceMessage;
                }).catch((error) => {
                    console.error('Error al obtener la URL:', error);
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },

            async fetchSessionPayload() {
                const guid = sessionStorage.getItem('ParamId');
                if (guid)
                    await ParamCotizService.getParamCotiz(guid);
            },

            setSessionParams() {
                const clientData = JSON.parse(sessionStorage.getItem("stepOneData")!);
                const rawPlan = JSON.parse(sessionStorage.getItem("PlanSelected")!);
                const rawGood = JSON.parse(sessionStorage.getItem("DataGood")!);
                const rawProduct = JSON.parse(sessionStorage.getItem("ProductDataSelected")!);
                const leadId = JSON.parse(sessionStorage.getItem("LeadId")!);
                const pricingId = rawPlan.pricingId[0];

                const payload = {
                    productId: 1000,
                    pricingId,
                    leadId,
                    contratante: {
                        firstName: clientData.firstName,
                        lastName: clientData.lastName,
                        documentNumber: clientData.documentNumber,
                        address: clientData.address,
                        areaCode: clientData.areaCode,
                        telephone: clientData.telephone,
                        email: clientData.email,
                    },
                    plan: {
                        planDescription: rawPlan.planDescription,
                        premioMensual: rawPlan.premioMensual,
                        capital: rawPlan.capital,
                    },
                    DataGood: {
                        goodBrand: rawGood.goodBrand,
                        goodModel: rawGood.goodModel,
                    },
                    ProductDataSelected: {
                        productDescription: rawProduct.productDescription,
                        planNote: rawProduct.planNote,
                    },
                    referente: this.referente,
                    medium: this.medium
                };

                const jsonString = JSON.stringify(payload);

                return ParamCotizService.setParamCotiz(jsonString)
                    .then(guid => {
                        this.GUiD = guid;
                    })
                    .catch(err => {
                        console.error("Error en setSessionParams:", err);
                    });
            },

            async getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");

                const today = new Date();
                const nextYearDate = new Date(today);
                nextYearDate.setFullYear(today.getFullYear() + 1);
                this.productDetails.effectDate = DateService.formatDate(today);
                this.productDetails.expirationDate = DateService.formatDate(nextYearDate);
                const coverData = JSON.parse(sessionStorage.getItem("cover"));
                const personData = JSON.parse(sessionStorage.getItem("stepOneData"));
                const planDataSelected = JSON.parse(sessionStorage.getItem("PlanSelected"));
                if (coverData != null) {
                    this.productDetails.cover = coverData;
                }
                if (personData != null) {
                    this.productDetails.name = personData.firstName + ' ' + personData.lastName;
                    this.productDetails.email = personData.email;
                    this.productDetails.telephone = personData.areaCode + '-' + personData.telephone;
                }
                if (planDataSelected != null) {
                    this.productDetails.planDescription = planDataSelected.planDescription;
                    this.productDetails.firstPaymentFee = planDataSelected.premioMensual;
                    this.productDetails.capital = planDataSelected.capital;
                    this.productDetails.undiscountedPrice = planDataSelected.premiumWithoutDiscount;
                    NF.UI.Page.blockCustom({ message: 'Cargando datos..' });
                    await DiscountRangeService.getElectronicEquipmentDiscountRange().then((response) => {
                        if (response.length > 0) {
                            this.productDetails.rate = response[0].discountMaxValue;
                        }
                    }).finally(() => {
                        NF.UI.Page.unblock();
                    });
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                await this.fetchSessionPayload();

                await this.pageCustomization();

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData(),
                    this.setSessionParams()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.getCUPE();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
